import React from 'react';
import FontAwesome from 'react-fontawesome';

class ArrowUp extends React.Component {
  render(){
    return(
      <a>          
        <FontAwesome name='angle-up'/>
      </a>
    );
  }
}
export default ArrowUp;
